import { forwardRef } from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import { SxProps } from '@mui/material/styles';

import { withSxProp } from 'common/utils/props';

const pageDrawerFooterStyle: SxProps = {
    position: 'fixed',
    px: { xs: 2, sm: 4 },
    py: 2,
    backgroundColor: 'grey.100',
    textAlign: 'center',
    bottom: 0,
    right: 0,
    width: '100%',
    maxWidth: '768px',
};

interface IProps extends BoxProps {
    sx?: SxProps;
}

export const PageDrawerFooter = forwardRef<HTMLDivElement, IProps>(
    ({ sx, ...other }, ref) => (
        <Box
            ref={ref}
            sx={[pageDrawerFooterStyle, ...withSxProp(sx)]}
            {...other}
        />
    )
);
